import axios from "axios";
import { ChangeEvent, useEffect, useState } from "react";
import { IoMdClose } from "react-icons/io";
import uploadFileToS3 from "../../../../fileuploader/fileUploader";
import { API_URL } from "../../../../url/api";
interface AssessmentReport {
  assessment_date: Date | null;
  //   is_assessment_submitted: boolean;
  assessment_pdf_url: string;
  doctor: number;
  //   session: string | null;
  user: number;
}

type UsersProps = {
  id: number;
  name: string;
  email: string;
  created_at: string;
  // label : string;
  // value : number;
};

const CreateAssessment = ({
  doctorID,
  showPopup,
  onClose,
  onCreated,
}: {
  doctorID: string;
  showPopup: boolean;
  onClose: () => void;
  onCreated: () => void;
}) => {
  const [users, setUsers] = useState<UsersProps[]>([]);

  const [report, setReport] = useState<AssessmentReport>({
    assessment_date: null,
    assessment_pdf_url: "",
    doctor: parseInt(doctorID),
    user: 0,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const fetchUsers = async () => {
      const doctorID = localStorage.getItem("doctorId");
      if (!doctorID) return;

      const { data } = await axios.get(
        `${API_URL}doctors/${doctorID}/client-list/`
      );
      console.log("🚀 ~ fetchUsers ~ data:", data);
      if (data) setUsers(data);
    };
    fetchUsers();
    return () => {};
  }, []);

  const uploadFile = async (
    e: React.ChangeEvent<HTMLInputElement & EventTarget & { files: FileList }>
  ) => {
    const file = e.target.files[0];

    // Check if file size is within 20MB
    const fileSizeInMB = file.size / (1024 * 1024);
    if (fileSizeInMB > 20) {
      alert("File size exceeds 20MB");
      return;
    }

    const res = await uploadFileToS3(file, "shvesa", file.name);
    console.log("🚀 ~ res:", res);
    if (res) {
      setReport((prevData) => ({
        ...prevData,
        assessment_pdf_url: res,
      }));
      console.log("🚀 ~ uploadFile ~ res:", res);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await axios.post(API_URL + "create/assessment/", report);
      setMessage("Assessment report uploaded successfully!");
      onResetData();
      setTimeout(() => {
        onCreated();
      }, 2000);
    } catch (error) {
      setMessage("Error uploading assessment report. Please try again.");
    }
    setIsLoading(false);
  };

  function onChangeUserList(event: ChangeEvent<HTMLSelectElement>): void {
    setReport({
      ...report,
      user: parseInt(event.target.value),
    });
  }

  const onResetData = () =>
    setReport({
      assessment_date: null,
      assessment_pdf_url: "",
      doctor: parseInt(doctorID),
      user: 0,
    });

  const onclose = () => {
    onResetData();
    onClose();
  };

  const isFromValid =
    report.assessment_date &&
    report.user &&
    report.assessment_pdf_url &&
    report.doctor
      ? true
      : false;
  console.log("🚀 ~ isFromValid:", report);

  if (!showPopup) return null;
  else
    return (
      <div className="fixed inset-0 flex items-center justify-center z-50 bg-gray-800 bg-opacity-75">
        <div className="bg-white rounded-lg shadow-lg overflow-hidden max-w-md w-full">
          <div className="flex flex-row items-center justify-between p-4 border-b">
            <h2 className="text-lg font-semibold">
              {"Upload Assessment Report"}
            </h2>
            <IoMdClose className="cursor-pointer" onClick={onclose} />
          </div>
          <div className="p-4">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block font-medium mb-1">Select User</label>
                <div className="relative inline-block w-full">
                  <select
                    className="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                    value={report.user}
                    onChange={onChangeUserList}
                  >
                    <option value={0} disabled selected>
                      {`Select User`}
                    </option>
                    {users &&
                      users.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.name}
                        </option>
                      ))}
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                    <svg
                      className="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 011.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                    </svg>
                  </div>
                </div>
              </div>

              <div className="mb-4">
                <label htmlFor="date" className="block mb-1 font-medium">
                  Assessment Date
                </label>
                <input
                  type="date"
                  id="date"
                  value={
                    report.assessment_date?.toISOString().split("T")[0] || ""
                  }
                  onChange={(e) =>
                    setReport({
                      ...report,
                      assessment_date: new Date(e.target.value),
                    })
                  }
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>

              <div className="mb-4">
                <label
                  className="block text-gray-700 text-sm font-bold mb-2"
                  htmlFor="phone"
                >
                  Upload Assessment PDF
                </label>
                <div className="flex items-center space-x-6">
                  <label className="block">
                    <span className="sr-only">Choose PDF</span>
                    <input
                      id="attach_cv"
                      required
                      type="file"
                      accept="application/pdf"
                      className="block w-full text-sm text-slate-500
                            file:mr-4 file:py-2 file:px-4
                            file:rounded-full file:border-0
                            file:text-sm file:font-semibold
                            file:bg-primary-50 file:text-gray-700
                            hover:file:bg-gray-100
                          "
                      onChange={uploadFile}
                    />
                  </label>
                </div>
              </div>

              <button
                type="submit"
                disabled={!isFromValid || isLoading}
                onClick={handleSubmit}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                {isLoading ? "Uploading..." : "Upload"}
              </button>
            </form>
            <p className="pt-4 text-center">{message}</p>
          </div>
        </div>
      </div>
    );
};

export default CreateAssessment;
